//
// Star an answer
//
// ---------------------------------------------------------------------------

'use strict';

const config = {
    clickEvent: 'click touch',
    commentTarget: '.js-comment-with-star',
    starButtonTarget: '.js-star__button',
    starTarget: '.js-comment-star',
    starredClass: 'c-star--chosen'
};

export default class StarAnswer {

    /**
     * If we have any voting comment cards then initalize
     */
    constructor() {
        let $commentCards = $(config.commentTarget);

        if (!$commentCards.length) {
            return;
        }

        this.setupClickEvents($commentCards);
    }

    /**
     * Loops through each voter comment card and
     * sets up click events for the stars on each one.
     *
     * @param {jQuery} $commentCards
     */
    setupClickEvents($commentCards) {
        $commentCards.on(config.clickEvent, config.starButtonTarget, (e) => this.selectStar(e));
    }

    /**
     * When a star is clicked, this function will determine whether to "choose" the star or not.
     *
     * @param {Event} e
     */
    selectStar(e) {
        e.preventDefault();

        let $starButton = $(e.currentTarget);
        let url = $starButton.attr('href');
        let $star = $starButton.find(config.starTarget);

        if ($star.hasClass(config.starredClass)) {
            return;
        }

        // We store previous star so that we can revert the chosen one back if the AJAX request fails.
        let $previousStar = $star;

        $(config.starTarget).removeClass(config.starredClass);

        $star.addClass(config.starredClass);

        $.post(url).fail(() => {
            $star.removeClass(config.starredClass);
            $previousStar.addClass(config.starredClass);
        });
    }
}

$(window).load(function() {
    new StarAnswer();
});



// WEBPACK FOOTER //
// ./src/js/components/star-answer.js